import { ListBase } from './../tools/ListBase';


class Precios extends ListBase {

  constructor ({props, context}) {
    super();
    this.state = {rows: [], cls: 'precios'};
    this.title = 'Precios';
    this.state.columns = [
      {
        field: 'FechaInicio',
        headerName: 'Fecha Inicio',
        width: 250,
      },
      {
        field: 'FechaFin',
        headerName: 'Fecha Fin',
        width: 250,
      },
    ];

  }

}


import { useNavigate } from 'react-router-dom';

function PreciosWithNavigate(props) {
  const navigate = useNavigate();
  return <Precios {...props} navigate={navigate} />;
}

export default PreciosWithNavigate;